
        import type { TemplateResult, TemplateRootPropsForTag } from 'Components/types';
type collapsibleVehicleWidgetRTRootProps = TemplateRootPropsForTag<'div'>;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function collapsibleVehicleWidgetRT(): TemplateResult<collapsibleVehicleWidgetRTRootProps> {
    function repeatSelects1(selects, selectsIndex) {
        return [selects(function () {
                function repeatEntry1(entry, entryIndex) {
                    return _createElement('option', {
                        'disabled': this.loading,
                        'value': entry.term,
                        'key': entry.value
                    }, '\n        ', entry.value, this.showHitCount ? ` (${ entry.hitCount })` : '', '\n      ');
                }
                return _createElement('div', { 'className': this.extraClassName }, _createElement('div', { 'className': 'cm_select_toggle cm_select_toggle__native cm_toggle-dropdown' }, this.index || this.index === 0 ? _createElement('span', {
                    'className': 'index',
                    'key': '118'
                }, this.index + 1) : null, _createElement.apply(this, [
                    'select',
                    {
                        'className': 'cm_select_inner-select cm_select__pretty',
                        'onChange': this.onChange,
                        'value': this.firstSelectedTerm ? this.firstSelectedTerm : '',
                        'aria-selected': this.selectedEntries.length ? true : false,
                        'disabled': this.disabled
                    },
                    !(this.hideNullOption && this.entries.some(e => e.selected)) ? _createElement('option', {
                        'value': '',
                        'key': 'null-option'
                    }, '\n        ', this.title, '\n      ') : null,
                    this.loading ? _createElement('option', {
                        'key': 'loading-option',
                        'disabled': true
                    }, _translate(`select_loading`)) : null,
                    _map(this.entries, repeatEntry1.bind(this))
                ])));
            }, { count: undefined })];
    }
    function repeatSelects2(selects, selectsIndex) {
        return [selects(function () {
                function repeatEntry1(entry, entryIndex) {
                    return _createElement('option', {
                        'disabled': this.loading,
                        'value': entry.term,
                        'key': entry.value
                    }, '\n        ', entry.value, this.showHitCount ? ` (${ entry.hitCount })` : '', '\n      ');
                }
                return _createElement('div', { 'className': this.extraClassName }, _createElement('div', { 'className': 'cm_select_toggle cm_select_toggle__native cm_toggle-dropdown' }, this.index || this.index === 0 ? _createElement('span', {
                    'className': 'index',
                    'key': '118'
                }, this.index + 1) : null, _createElement.apply(this, [
                    'select',
                    {
                        'className': 'cm_select_inner-select cm_select__pretty',
                        'onChange': this.onChange,
                        'value': this.firstSelectedTerm ? this.firstSelectedTerm : '',
                        'aria-selected': this.selectedEntries.length ? true : false,
                        'disabled': this.disabled
                    },
                    !(this.hideNullOption && this.entries.some(e => e.selected)) ? _createElement('option', {
                        'value': '',
                        'key': 'null-option'
                    }, '\n        ', this.title, '\n      ') : null,
                    this.loading ? _createElement('option', {
                        'key': 'loading-option',
                        'disabled': true
                    }, _translate(`select_loading`)) : null,
                    _map(this.entries, repeatEntry1.bind(this))
                ])));
            }, { count: undefined })];
    }
    return window.location.pathname === '/' || window.location.pathname.includes('/pages/search') || window.location.pathname.includes('/collections') ? _createElement('div', {
        'className': 'cm_vehicle-widget cm_vehicle-widget__home cm_vehicle-widget__header cm_vehicle-widget__collapsible container',
        'key': '75'
    }, !this.withCollapsing ? _createElement('div', {
        'className': 'cm_vehicle-widget_dropdowns',
        'key': '377'
    }, _createElement('div', { 'className': 'cm_vehicle-widget_title' }, this.name === 'HomeVehicleWidget_tab' ? 'Other Vehicles' : 'Select Your Vehicle'), _createElement('div', { 'className': 'cm_vehicle-widget_body' }, _createElement.apply(this, [
        'div',
        { 'className': 'cm_vehicle-widget_select-container  cmRepeater_selects' },
        _map(this.selects, repeatSelects1.bind(this))
    ]), _createElement('div', { 'className': 'cm_vehicle-widget_button-container' }, _createElement('div', {
        'className': 'cm_vehicle-widget_button cm_vehicle-widget_button__go btn btn--primary',
        'onClick': this.selectVehicle,
        'disabled': !this.allowToSetVehicle,
        'role': 'button',
        'tabIndex': this.allowToSetVehicle ? '0' : '-1'
    }, this.name === 'HomeVehicleWidget_tab' ? [
        _createElement('svg', {
            'className': 'cm_mobile-hide',
            'xmlns': 'http://www.w3.org/2000/svg',
            'width': '20',
            'height': '20',
            'viewBox': '0 0 20 20',
            'fill': 'none',
            'key': '26740'
        }, _createElement('g', { 'id': 'arrow-right-02' }, _createElement('path', {
            'id': 'Vector',
            'd': 'M12.5004 5.83363L16.667 10.0004L12.5003 14.167',
            'stroke': 'url(#paint0_linear_5858_3635)',
            'strokeLinecap': 'square',
            'strokeLinejoin': 'round'
        }), _createElement('path', {
            'id': 'Vector_2',
            'd': 'M16.25 10L3.75 10',
            'stroke': 'url(#paint1_linear_5858_3635)',
            'strokeLinecap': 'square',
            'strokeLinejoin': 'round'
        })), _createElement('defs', {}, _createElement('linearGradient', {
            'id': 'paint0_linear_5858_3635',
            'x1': '18.4112',
            'y1': '16.3495',
            'x2': '10.0194',
            'y2': '15.3322',
            'gradientUnits': 'userSpaceOnUse'
        }, _createElement('stop', { 'stopColor': 'white' }), _createElement('stop', {
            'offset': '1',
            'stopColor': '#999999'
        })), _createElement('linearGradient', {
            'id': 'paint1_linear_5858_3635',
            'x1': '21.4826',
            'y1': '10.2619',
            'x2': '18.9744',
            'y2': '2.66057',
            'gradientUnits': 'userSpaceOnUse'
        }, _createElement('stop', { 'stopColor': 'white' }), _createElement('stop', {
            'offset': '1',
            'stopColor': '#999999'
        })))),
        _createElement('svg', {
            'xmlns': 'http://www.w3.org/2000/svg',
            'viewBox': '0 0 20 20',
            'fill': 'none',
            'className': 'h-full w-full cm_desktop-hide',
            'key': '26742'
        }, _createElement('path', {
            'd': 'M4.75 10H14.25M14.25 10L10.5 6.25M14.25 10L10.5 13.75',
            'stroke': 'currentColor',
            'strokeWidth': '1.9',
            'strokeLinecap': 'round',
            'strokeLinejoin': 'round'
        }))
    ] : null, this.name !== 'HomeVehicleWidget_tab' ? _translate(`ymm_bar_submit`) : '', '\n  '), _createElement('div', {
        'className': 'cm_vehicle-widget_button cm_vehicle-widget_button__clear btn btn--secondary',
        'onClick': this.discardVehicle,
        'disabled': !this.allowToDiscardVehicle,
        'role': 'button',
        'tabIndex': this.allowToDiscardVehicle ? '0' : '-1'
    }, [_createElement('svg', {
            'xmlns': 'http://www.w3.org/2000/svg',
            'className': 'cm_icon cm_icon-reset',
            'height': '16px',
            'viewBox': '0 0 16 16',
            'key': '43240'
        }, _createElement('path', { 'd': 'M2.083,9H0.062H0v5l1.481-1.361C2.932,14.673,5.311,16,8,16c4.08,0,7.446-3.054,7.938-7h-2.021 c-0.476,2.838-2.944,5-5.917,5c-2.106,0-3.96-1.086-5.03-2.729L5.441,9H2.083z' }), _createElement('path', { 'd': 'M8,0C3.92,0,0.554,3.054,0.062,7h2.021C2.559,4.162,5.027,2,8,2c2.169,0,4.07,1.151,5.124,2.876 L11,7h2h0.917h2.021H16V2l-1.432,1.432C13.123,1.357,10.72,0,8,0z' }))])))) : null, this.withCollapsing ? _createElement('div', {
        'className': 'cm_vehicle-widget_header',
        'onClick': this.toggleCollapsed,
        'key': '4849'
    }, _createElement('span', { 'className': 'cm_vehicle-widget_header-label' }, !this.isVehicleSelected ? [this.name === 'HomeVehicleWidget_tab' ? 'Other Vehicles' : 'Select Your Vehicle'] : null, this.isVehicleSelected ? [this.vehicleString] : null), !this.collapsed ? [_createElement('svg', {
            'className': 'cm_icon cm_icon-angle up',
            'height': '20px',
            'role': 'img',
            'viewBox': '39 30 565 565',
            'aria-hidden': 'true',
            'key': '52750'
        }, _createElement('path', { 'd': 'M600,189q0-7-6-12l-28-28q-5-6-12-6t-13,6l-220,219-219-219q-5-6-13-6t-12,6l-28,28q-6,5-6,12t6,13l260,260q5,6,12,6t13-6l260-260q6-5,6-13z' }))] : null, this.collapsed ? [_createElement('svg', {
            'className': 'cm_icon cm_icon-angle down',
            'height': '20px',
            'role': 'img',
            'viewBox': '39 30 565 565',
            'aria-hidden': 'true',
            'key': '55930'
        }, _createElement('path', { 'd': 'M600,189q0-7-6-12l-28-28q-5-6-12-6t-13,6l-220,219-219-219q-5-6-13-6t-12,6l-28,28q-6,5-6,12t6,13l260,260q5,6,12,6t13-6l260-260q6-5,6-13z' }))] : null) : null, this.withCollapsing ? _createElement('div', {
        'className': 'cm_collapsible-elem',
        'key': '5919'
    }, _createElement('div', { 'className': 'cm_vehicle-widget_dropdowns' }, _createElement('div', { 'className': 'cm_vehicle-widget_body' }, _createElement.apply(this, [
        'div',
        { 'className': 'cm_vehicle-widget_select-container  cmRepeater_selects' },
        _map(this.selects, repeatSelects2.bind(this))
    ]), _createElement('div', { 'className': 'cm_vehicle-widget_button-container' }, _createElement('div', {
        'className': 'cm_vehicle-widget_button cm_vehicle-widget_button__go btn btn--primary',
        'onClick': this.selectVehicle,
        'disabled': !this.allowToSetVehicle,
        'role': 'button',
        'tabIndex': this.allowToSetVehicle ? '0' : '-1'
    }, this.name === 'HomeVehicleWidget_tab' ? [
        _createElement('svg', {
            'className': 'cm_mobile-hide',
            'xmlns': 'http://www.w3.org/2000/svg',
            'width': '20',
            'height': '20',
            'viewBox': '0 0 20 20',
            'fill': 'none',
            'key': '80950'
        }, _createElement('g', { 'id': 'arrow-right-02' }, _createElement('path', {
            'id': 'Vector',
            'd': 'M12.5004 5.83363L16.667 10.0004L12.5003 14.167',
            'stroke': 'url(#paint0_linear_5858_3635)',
            'strokeLinecap': 'square',
            'strokeLinejoin': 'round'
        }), _createElement('path', {
            'id': 'Vector_2',
            'd': 'M16.25 10L3.75 10',
            'stroke': 'url(#paint1_linear_5858_3635)',
            'strokeLinecap': 'square',
            'strokeLinejoin': 'round'
        })), _createElement('defs', {}, _createElement('linearGradient', {
            'id': 'paint0_linear_5858_3635',
            'x1': '18.4112',
            'y1': '16.3495',
            'x2': '10.0194',
            'y2': '15.3322',
            'gradientUnits': 'userSpaceOnUse'
        }, _createElement('stop', { 'stopColor': 'white' }), _createElement('stop', {
            'offset': '1',
            'stopColor': '#999999'
        })), _createElement('linearGradient', {
            'id': 'paint1_linear_5858_3635',
            'x1': '21.4826',
            'y1': '10.2619',
            'x2': '18.9744',
            'y2': '2.66057',
            'gradientUnits': 'userSpaceOnUse'
        }, _createElement('stop', { 'stopColor': 'white' }), _createElement('stop', {
            'offset': '1',
            'stopColor': '#999999'
        })))),
        _createElement('svg', {
            'xmlns': 'http://www.w3.org/2000/svg',
            'viewBox': '0 0 20 20',
            'fill': 'none',
            'className': 'h-full w-full cm_desktop-hide',
            'key': '80952'
        }, _createElement('path', {
            'd': 'M4.75 10H14.25M14.25 10L10.5 6.25M14.25 10L10.5 13.75',
            'stroke': 'currentColor',
            'strokeWidth': '1.9',
            'strokeLinecap': 'round',
            'strokeLinejoin': 'round'
        }))
    ] : null, this.name !== 'HomeVehicleWidget_tab' ? _translate(`ymm_bar_submit`) : '', '\n  '), _createElement('div', {
        'className': 'cm_vehicle-widget_button cm_vehicle-widget_button__clear btn btn--secondary',
        'onClick': this.discardVehicle,
        'disabled': !this.allowToDiscardVehicle,
        'role': 'button',
        'tabIndex': this.allowToDiscardVehicle ? '0' : '-1'
    }, [_createElement('svg', {
            'xmlns': 'http://www.w3.org/2000/svg',
            'className': 'cm_icon cm_icon-reset',
            'height': '16px',
            'viewBox': '0 0 16 16',
            'key': '97450'
        }, _createElement('path', { 'd': 'M2.083,9H0.062H0v5l1.481-1.361C2.932,14.673,5.311,16,8,16c4.08,0,7.446-3.054,7.938-7h-2.021 c-0.476,2.838-2.944,5-5.917,5c-2.106,0-3.96-1.086-5.03-2.729L5.441,9H2.083z' }), _createElement('path', { 'd': 'M8,0C3.92,0,0.554,3.054,0.062,7h2.021C2.559,4.162,5.027,2,8,2c2.169,0,4.07,1.151,5.124,2.876 L11,7h2h0.917h2.021H16V2l-1.432,1.432C13.123,1.357,10.72,0,8,0z' }))]))))) : null) : null;
}
        export const componentNames = []